import { Middleware, Context } from '@nuxt/types'

const maintenanceRouteName = 'maintenance'

const maintenanceMiddleware: Middleware = ({ redirect, route }: Context) => {
  const maintenanceEnabled = process.env.APP_MAINTENANCE_ENABLED === 'true'

  if (route.name !== maintenanceRouteName && maintenanceEnabled) {
    return redirect('/maintenance')
  }

  if (route.name === maintenanceRouteName && !maintenanceEnabled) {
    return redirect('/')
  }
}

export default maintenanceMiddleware
